import React, { useEffect } from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import { useNavigate } from "react-router-dom";
import { selectPermittedActions } from "../ui/permittedActionsReducer";
import { useSelector, useDispatch } from "react-redux";
import { activateMenu, selectedMenuChange } from '../ui/sidebarMenuReducer.js';

const Page = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permittedActions = useSelector(selectPermittedActions);

  useEffect(() => {
    if(permittedActions.permittedActions.indexOf(props.uiPage.linkedUiAction.actionName) === -1) {
      navigate('/dashboard');
    } else {
      dispatch(activateMenu(selectedMenuChange(props.uiPage.linkedUiMenu.uiAction.actionName)));
    }
  }, [])

  return <div className={`page ${props.className}`}>
    { props.breadcrumbs && (props.breadcrumbs.length > 0) && <Breadcrumbs breadcrumbs={props.breadcrumbs}></Breadcrumbs> }
    { props.contentTop }
    { props.children }
  </div>
}

export default Page;
